import { NeckDiagramStudentView, NeckDiagramHandedness } from "./neckDiagrams/NeckDiagramStudentView.js";
import { Link } from "react-router-dom";
import { ApiError } from "./api.js";
import { useAsync } from "./useAsync.js";
import { neckDiagramsForStudent, neckDiagramShareHref } from "./neckDiagrams/api.js";

export function StudentNeckDiagrams({ studentId, family = false }: { studentId: string; family?: boolean }) {
  return <NeckDiagramStudentView studentId={studentId}><NeckDiagramHandedness /><StudentSheets studentId={studentId} family={family} /></NeckDiagramStudentView>;
}
function StudentSheets({ studentId, family }: { studentId: string; family: boolean }) {
  const result = useAsync(async () => {
    try { return await neckDiagramsForStudent(studentId); }
    catch (error) { if (error instanceof ApiError && error.status === 404) return null; throw error; }
  }, [studentId]);
  if (result.error) return <section className="panel"><p className="error" role="alert">Neck diagrams could not be loaded: {result.error}</p><button type="button" onClick={result.reload}>Try again</button></section>;
  const shared = result.data?.shared ?? [], authored = result.data?.authored ?? [];
  // The feature has no surface for School-only learners or unrelated tutors.
  if (!shared.length && (family || !authored.length)) return null;
  return <section className="panel" aria-label="Student neck diagrams">
    <h2>{family ? "Neck diagrams for practice" : "Neck diagrams"}</h2>
    {shared.length > 0 && <ul className="neck-library-list">{shared.map(sheet => <li key={sheet.shareId}>
      <Link to={neckDiagramShareHref(sheet.shareId)}>{sheet.title}</Link>
      {sheet.note && <p>{sheet.note}</p>}
      {sheet.practiceTodoId && !sheet.withdrawnAt && <span className="badge">{sheet.practiceDone ? "Practised" : "Set as practice"}</span>}
    </li>)}</ul>}
    {!family && authored.length > 0 && <><h3>Student's own diagrams</h3><p className="small muted">Open a sheet to view it or make your own copy. The student keeps their original.</p>
      <ul className="neck-library-list">{authored.map(sheet => <li key={sheet.id}><Link to={`/neck-diagrams/${sheet.id}?studentId=${encodeURIComponent(studentId)}`}>{sheet.title}</Link></li>)}</ul></>}
  </section>;
}
